import styles from "./domaineManagement.module.scss";
import {IDomaine} from "../../cdsApiSlice";
import RowList from "../../../../components/list/RowList";
import Title from "../../../../components/list/Title";
import Actions from "../../../../components/list/Actions";
import Indicators from "../../../../components/list/Indicators";
import TextRight from "../../../../components/list/TextRight";

interface IDomainsList {
  domains: IDomaine[];
}

//This component include : the search field, list of domaines with page
const DomainsList = ({ domains }: IDomainsList) => {

  const DomainListItem = (domain: IDomaine) => {
    return (
      <RowList
        type={"domaine"}
        id={domain.id.toString()}
        key={domain.id}
        title={<Title title={domain.libelle}/>}
        description={domain.description}
        actions={<Actions element={domain} type={"domaine"} />}
        indicators={<Indicators type={"domaine"} element={domain}/>}
        rightInformation={<TextRight type={"domaine"} element={domain}/>}
        labels={domain.labels ? domain.labels : null}
      />
    );
  }

  return (
    <>
      <div className={styles.filerDomainList}>
        <div>
          <div>
            {
              domains.map(DomainListItem)
            }
          </div>

        </div>
      </div>
    </>
  );
};

export default DomainsList;
